import React, { useRef, useEffect, useCallback, useState} from 'react';
import ExpandedProject from './ExpandedProject.js';
import UnknownProgressBar from 'components/progressbar/UnknownProgressBar.js';
import ProjectOption from './ProjectOption.js';
import {connect} from 'react-redux';
import {useScroll} from 'components/selector2/useScroll.js';
import {getProjects} from './getProjects.js';

const SequencesList = ({
    guildId,
    viewMode,
    sequencerEngine,
    searchTerm,
    filterMine,
    setExpandedProject,
    expandedProject,
    starred,
    favorited,
    old
}) => { 
    const [results, setResults] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const ref = useRef(undefined);
    let {size} = useScroll(ref, 24, true, searchTerm, expandedProject);

    useEffect(() => {
        if (expandedProject) {
            return;
        }
        setIsLoading(true);
        getProjects(searchTerm, filterMine, starred, favorited, undefined, undefined, guildId, undefined, old).then(
            x => {
                setIsLoading(false);
                if (viewMode === "GRID") {
                    x = x.filter(x => x.metadata && x.metadata.thumbnail);
                }
                setResults(x);
            });
    }, [viewMode, searchTerm, old, setResults, filterMine, setIsLoading, expandedProject, starred, favorited, guildId]);
    let style = {
        height: window.innerHeight - 216
    };
    let className =expandedProject ? "has-expanded-project sequences-list" : "sequences-list";
    if (viewMode === "GRID") {
        className += " grid-mode";
    }
    return (
        <div ref={ref} style={style} className={className}>
          {isLoading ? 
           <UnknownProgressBar text="Loading Projects"/> : 
           expandedProject ?
           <div className="project-and-back">
             <div
               onClick={() => setExpandedProject(undefined)}
               className="selector-back-button"/>
             <ProjectOption
               setExpandedProject={setExpandedProject}
               viewMode={viewMode}
               sequencerEngine={sequencerEngine}
               project={expandedProject}
               expanded={true}/>
           </div>
           : results.slice(0, size).map(
               (x,i) =>
                   <ProjectOption
                     viewMode={viewMode}
                     odd={i%2===1}
                     key={i + '-' + x.newSequence}
                     setExpandedProject={setExpandedProject}
                     sequencerEngine={sequencerEngine}
                     project={x}/>)}
          {expandedProject ?
           <ExpandedProject project={expandedProject} sequencerEngine={sequencerEngine}/> :
           ''}
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
      guildId: state.guilds.selectedGuild ? state.guilds.selectedGuild.guildId : 0
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SequencesList);
